module.exports = __webpack_public_path__ + "assets/img/18_1825.86e29bf3.jpg";